
	import Vue from "vue"
	import Component from "vue-class-component"
	import { Prop, Watch } from "vue-property-decorator"

	import IcsIcon from "custom/ui/IcsIcon.vue"
	import MessageList from "custom/MessageList.vue"

	import { Message } from "store/messages/types"
	import { isUndefined } from "lodash-es"

	@Component({
		components: {
			MessageList,
			IcsIcon
		}
	})
	export default class MessageBox extends Vue {
		@Prop({type: Array, required: true}) messages!: Array<Message>
		@Prop({type: Object, required: false, default: null}) value!: Message | null

		selectedMessage: Message | null = null

		async mounted(): Promise<void> {
			await Vue.nextTick()
			this.$emit("input", this.value)
			this.value ? this.selectedMessage = this.value : this.selectedMessage = null
		}

		@Watch("selected")
		selectedChanged(): void {
			if (!isUndefined(this.value)) {
				this.selectMessage(this.value)
			}
		}

		@Watch("selectedMessage")
		selectMessage(message: Message | null): void {
			this.$emit("input", message)
		}
	}
